/* eslint-disable no-unexpected-multiline */
import types from '../types'

// To be used when beginning a new minor element
// Response is used to map out questions and show user progress

// -Flattens out all the questions in a minor element into a 1d array
// -Each question stores associated meta data (from parents)
// -Stores a local copy of the prompt1Response with flattened array and progress

export const flattenSubSectionQuestions = (props) => (dispatch) => {
  const {
    prompt1Response,
    selectedSectionName,
    selectedSectionIndex,
    selectedSubSectionName,
    selectedSubSectionIndex,
  } = props

  // data: 'Minor Element/SubSection'
  // pq: 'Potential Question in Details'
  // ufq: 'User Facing Question'

  const data = prompt1Response[selectedSectionName][selectedSubSectionName]

  /*
    Local data is duplicate of Minor Element/subSection
    with metadata for progress
  */

  const localData = {
    ...data,
    total: 0,
    completed: 0,
  }

  const flattenedQuestions = []

  const pqIds = Object.keys(data.Questions)
  pqIds.forEach((pqId, i) => {
    const pq = data.Questions[pqId]
    const ufqIds = Object.keys(pq['User Facing Question'])
    ufqIds.forEach((ufqId, j) => {
      const ufq = pq['User Facing Question'][ufqId]
      const flattenedQuestion = {
        ...ufq,
        ...pq,
        pqId,
        ufqId,
        pqIdIndex: i,
        ufqIdIndex: j,
        sectionName: selectedSectionName,
        sectionIndex: selectedSectionIndex,
        subSectionName: selectedSubSectionName,
        subSectionIndex: selectedSubSectionIndex,
      }
      flattenedQuestions.push(flattenedQuestion)
      if (ufq.Answer) {
        localData.completed += 1
      }
      localData.total += 1
    })
  })

  const localPrompt1Response = {
    ...prompt1Response,
  }

  localPrompt1Response
      [selectedSectionName]
      [selectedSubSectionName]
      ['Local Data'] =
        localData
  localPrompt1Response
      [selectedSectionName]
      [selectedSubSectionName]
      ['Flattened Questions'] =
        flattenedQuestions
  dispatch({
    type: types.STORE_PAYLOAD,
    payload: {
      localPrompt1Response,
      time: Date.now(),
      currentPqIdIndex: 0,
      currentUfqIdIndex: 0,
      currentPqId: flattenedQuestions[0].pqId,
      currentUfqId: flattenedQuestions[0].ufqId,
    },
  })
}
